import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.veranstaltung-info-kategorie-reihenfolge-setzen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungInfoKategorieReihenfolgeSetzenEffects {

    VeranstaltungInfoKategorieReihenfolgeSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_VERANSTALTUNG_INFO_KATEGORIE_REIHENFOLGE_SETZEN),
        mergeMap((x: ac.PostVeranstaltungInfoKategorieReihenfolgeSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postVeranstaltungInfoKategorieReihenfolgeSetzen(x.infoKategorieReihenfolgeSetzenMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostVeranstaltungInfoKategorieReihenfolgeSetzenErfolgreichAction(result, x.infoKategorieReihenfolgeSetzenMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostVeranstaltungInfoKategorieReihenfolgeSetzenFehlerAction(error, x.infoKategorieReihenfolgeSetzenMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AdminCommandService);
        }
        return this.service;
    }
}
